import { labels } from 'presentation/constant/labels'

export const validateFields = (field: string) => {
  if (field === '') {
    return labels.form.requiredFieldText
  }
  return ''
}
